// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","buttons":"_2wk-mUMvgFiU","modal":"_2BvXLNsfyfwe","button":"uj15Liq5DZoa","active":"grrhNXNBhUOQ"};